import React, { useState } from 'react';
import { MANAGEMENT_PAYMENT_STATUS } from '../../../constants/TaxPortal/MANAGEMENT_CONTACT_TYPE';
import useForm from '../../../hooks/useForm';
import Modal, { ModalHeader } from '../../Modal';
import Form from '../../Form';
import { getDay } from "../../../utils/date";
const defaultForm = {
  status: "complate",
  payDate: getDay()
};
const PaymentStatusChange = (props) => {
  const { open, setOpen, submit } = props;

  const cancel = (e, form) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    submit && form && submit(form);
  };

  const [fields] = useState([
    {
      title: "상태",
      key: "status",
      type: "select",
      options: {
        list: MANAGEMENT_PAYMENT_STATUS
      }
    },
    {
      title: "납부일",
      key: "payDate",
      type: "datepicker",

    }
  ]);

  const _submit = (form) => {
    cancel(undefined, form);
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
  } = useForm(
    defaultForm,
    _submit,
  );

  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
        className="taxPortal-billing-detail"
      >
        <ModalHeader>
          결제 상태 변경
        </ModalHeader>

        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={"변경"}
          submit={handleSubmit}
          cancel={cancel}
        />
      </Modal>
    </>
  );
};

export default PaymentStatusChange;